import Radium from '@flipdish/radium';
import * as React from 'react';
import { AppDesignScheme } from '../../Api';

interface Props {
  AppDesignScheme: AppDesignScheme;
  isDark: boolean;
  readonly?: boolean;
}

interface State {}

export class LoadingPanel extends React.Component<Props, State> {
  public render(): JSX.Element {
    const { AppDesignScheme, isDark } = this.props;

    const styles = {
      loading: {
        backgroundColor: AppDesignScheme.Primary
      },
      darkLoading: {
        backgroundColor: AppDesignScheme.Tertiary
      },
      outerBall: {
        borderColor: AppDesignScheme.Secondary,
        borderTopColor: 'rgba(0,0,0,0)',
        borderLeftColor: 'rgba(0,0,0,0)',
        boxShadow: `0 0 35px ${AppDesignScheme.Secondary}`
      },
      innerBall: {
        borderColor: AppDesignScheme.Secondary,
        borderTopColor: 'rgba(0,0,0,0)',
        borderLeftColor: 'rgba(0,0,0,0)',
        boxShadow: `0 0 15px ${AppDesignScheme.Secondary}`
      }
    };

    return (
      <div
        className={`container-fluid ${isDark ? 'dark' : 'light'} ${
          process.env.NODE_ENV === 'test' ? 'no-animate' : ''
        }`}
      >
        <div
          className={`fd-loading ${
            this.props.readonly ? '' : 'fd-loading--non-readonly'
          }`}
          style={isDark ? styles.darkLoading : styles.loading}
        >
          <div className="center-absolute">
            <div className="ball" style={styles.outerBall} />
          </div>
          <div className="center-absolute">
            <div className="ball1" style={styles.innerBall} />
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(LoadingPanel);
